/** Feature-local TanStack QueryClient per admin-fatture (F-011 rescoped). */
import { QueryClient } from '@tanstack/react-query';

export function createFattureQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
      mutations: { retry: 0 },
    },
  });
}

export const fattureQueryClient = createFattureQueryClient();
export const fattureQueryKey = (filters: { stato?: string; page?: number }) =>
  ['admin', 'fatture', filters] as const;
